import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { Capacitor } from '@capacitor/core';
import { API_VERSION } from './environments/version';

if (environment.production) {
  enableProdMode();
}

// Apps nativos apontam para versão específica da API no App Engine
// Web sempre usa a versão default (sem prefixo)
// baseUrlApiDefault NÃO é sobrescrita: o version check precisa consultar a API
// default — a congelada tem LATEST_CLIENT_VERSION baked do próprio release e
// responderia "você está na última versão" para sempre.
if (Capacitor.isNativePlatform() && environment.production) {
  environment.baseUrlApi = `https://${API_VERSION}-dot-api-dot-app-smart-leiloes.uk.r.appspot.com/api`;
}

registerLocaleData(localePt);

bootstrapApplication(AppComponent, appConfig);
